import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '../../../components/buttons/Button';

import {
    getTemplateId,
    getTemplateTitle,
    getTemplateType,
    getTemplateEntryDisplayName,
} from '../boardTemplatePickerUtil';

import './BoardTemplatePickerBodyListingButton.scss';
import './BoardTemplatePickerBodyListingTemplateButton.scss';

const TemplateButton = ({
    templateEntry,
    templates,
    isTopPick,
    isCustomTemplate,
    selectedTemplateId,
    selectTemplate,
}) => {
    const templateId = getTemplateId(templateEntry);
    const template = templates.get(templateId);

    const title = getTemplateEntryDisplayName(templateEntry) || getTemplateTitle(template);
    const type = getTemplateType(template);

    const classes = classNames('TemplatePickerListingButton TemplateButton', type && type.toLowerCase(), {
        selected: selectedTemplateId === templateId,
    });

    return (
        <Button className={classes} onClickFn={() => selectTemplate(templateId)}>
            <span className="title">{title}</span>

            {isTopPick && !isCustomTemplate && <span className="status-tag">Top pick</span>}
            {isCustomTemplate && <span className="status-tag">Custom</span>}
        </Button>
    );
};

TemplateButton.propTypes = {
    isTopPick: PropTypes.bool,
    isCustomTemplate: PropTypes.bool,
    templateEntry: PropTypes.object,
    templates: PropTypes.object,
    selectedTemplateId: PropTypes.string,
    selectTemplate: PropTypes.func,
};

export default TemplateButton;
